import { render } from "./ArchaicNavigation.vue?vue&type=template&id=c7e7b0ae"
import script from "./ArchaicNavigation.vue?vue&type=script&lang=js"
export * from "./ArchaicNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__